import axiosClient from '../clients/axiosClient';

export interface CreateFollowOnRequest {
  member_id: string;
  description: string;
  follow_on_date: string;
  mentioned_user_ids?: string[];
}

export interface FollowOnAuthor {
  id: string;
  first_name: string;
  last_name: string;
  role: string;
}

export interface FollowOnItem {
  id: number;
  description: string;
  follow_on_date: string;
  created_at: string;
  updated_at: string;
  author: FollowOnAuthor;
}

export interface CreateFollowOnResponse extends FollowOnItem {}

export const createFollowOn = async (
  payload: CreateFollowOnRequest
): Promise<CreateFollowOnResponse> => {
  const response = await axiosClient.post('/api/v1/follow-on/', payload);
  return response.data;
};

export interface ListFollowOnParams {
  member_id: string;
  limit?: number;
  offset?: number;
  sort_field?: 'created_at' | 'updated_at' | 'follow_on_date' | null;
  sort_order?: 'asc' | 'desc';
}

export interface ListFollowOnResponse {
  items: FollowOnItem[];
  total_count: number;
}

export const listFollowOn = async (
  params: ListFollowOnParams
): Promise<ListFollowOnResponse> => {
  const search = new URLSearchParams({
    member_id: params.member_id,
  });
  if (params.limit !== undefined) search.append('limit', String(params.limit));
  if (params.offset !== undefined) search.append('offset', String(params.offset));
  if (params.sort_field) search.append('sort_field', params.sort_field);
  if (params.sort_order) search.append('sort_order', params.sort_order);

  const response = await axiosClient.get(`/api/v1/follow-on/list?${search.toString()}`);
  return response.data;
};

export interface DeleteFollowOnRequest {
  follow_on_id: number;
}

export interface DeleteFollowOnResponse {
  follow_on_id: number;
  status: string;
  message: string;
}

export const deleteFollowOn = async (
  payload: DeleteFollowOnRequest
): Promise<DeleteFollowOnResponse> => {
  const response = await axiosClient.delete('/api/v1/follow-on/', { data: payload });
  return response.data;
};

export interface EditFollowOnRequest {
  follow_on_id: number;
  description?: string;
  follow_on_date?: string;
  mentioned_user_ids?: string[];
}

export interface EditFollowOnResponse {
  status: string;
}

export const editFollowOn = async (
  payload: EditFollowOnRequest
): Promise<EditFollowOnResponse> => {
  const response = await axiosClient.patch('/api/v1/follow-on/', payload);
  return response.data;
};

export const getFollowOnById = async (followOnId: number): Promise<FollowOnItem> => {
  const response = await axiosClient.get(`/api/v1/follow-on/${followOnId}`);
  return response.data;
};


